export default class QuizLoadError {}
